/* eslint-disable no-console */
import { api } from "@/lib/api";

/**
 * Lightweight, fire-and-forget client-side analytics helper.
 * Posts to /api/analytics/event. Never throws. Generates a per-session id
 * stored in sessionStorage so a single visit has a stable identifier.
 */

const SESSION_KEY = "am_session_id";

function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = "s_" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

const fired = new Set(); // De-dupe one-shot events per session.

export function track(event, props = {}, { once = false } = {}) {
  if (!event) return;
  const key = `${event}::${JSON.stringify(props)}`;
  if (once && fired.has(key)) return;
  if (once) fired.add(key);
  try {
    api.post(
      "/analytics/event",
      {
        event,
        session_id: getSessionId(),
        props,
        url: typeof window !== "undefined" ? window.location.pathname : null,
      },
      { timeout: 4000 },
    ).catch(() => {});
  } catch {
    /* never let analytics break the UI */
  }
}

export default { track };
